function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon/building02");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "icon/building02",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "house",
  transform: "translate(22.000000, 53.000000)",
  fillRule: "nonzero",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,-3.55271368e-15 L0,32.1726394 L0,46.4046514 C0,51.6820931 4.27751463,56 9.56812483,56 C9.65254946,56 9.70883254,56 9.79325717,56 C9.87768181,56 9.93396489,56 10.0183895,56 L29.8863193,56 C34.839231,56 38.8634717,51.9643093 38.8634717,46.9973053 L38.8634717,23.6966065 C38.8634717,22.9346229 39.4825857,22.3137475 40.2424074,22.3137475 L60.7575926,22.3137475 C61.5174143,22.3137475 62.1365283,22.9346229 62.1365283,23.6966065 L62.1365283,46.9973053 C62.1365283,50.3086413 76.8156282,36.0774432 106.173828,4.30371094",
  id: "Shape"
})), /*#__PURE__*/React.createElement("polyline", {
  id: "Path-9",
  stroke: "currentColor",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  points: "2 72 72.9021842 3 128 57.3037109"
}), /*#__PURE__*/React.createElement("g", {
  id: "wrench",
  transform: "translate(66.000000, 50.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  stroke: "currentColor",
  strokeWidth: 4
}, /*#__PURE__*/React.createElement("path", {
  d: "M72.6545334,51.6821351 C68.6962827,47.7240598 62.8705311,46.3482425 57.5921907,48.0593978 L28.940516,19.4078695 C30.6515248,14.129556 29.2757004,8.30367895 25.3177602,4.34544839 C21.1477485,0.175768573 14.9049959,-1.1286342 9.41318683,1.02373905 C8.98982042,1.18970032 8.67838917,1.55795114 8.5853945,2.0032055 C8.49239982,2.44830462 8.63010646,2.91048113 8.9517842,3.23215723 L17.5279425,11.8081165 L11.8080714,17.5278031 L3.23206835,8.95168862 C2.91023536,8.63016777 2.44867749,8.49277233 2.00311035,8.58530079 C1.55785371,8.67829499 1.18944576,8.98956939 1.02363889,9.41308889 C-1.12843486,14.9045594 0.175508832,21.1474354 4.34536519,25.317581 C8.30361598,29.2756563 14.1293675,30.6517841 19.407708,28.9403183 L30.1211913,39.6537469 L36.7944518,46.3271286 L48.0595379,57.5921572 C46.3483738,62.8704707 47.7243534,68.6963477 51.682449,72.6545782 C54.5177774,75.4897369 58.3109976,77 62.175167,77 C63.9940745,77 65.829128,76.6651277 67.5868671,75.9764428 C68.0102335,75.8104815 68.3216647,75.4422307 68.4146594,74.9969764 C68.5076541,74.5518772 68.3699474,74.0897007 68.0482697,73.7680246 L59.4721114,65.1919102 L65.1918273,59.4723788 L73.7678303,68.048338 C74.089508,68.3700141 74.5513764,68.5080305 74.9967883,68.4147258 C75.4420449,68.3217316 75.8104529,68.0104572 75.9762597,67.5869377 C78.1284887,62.0951567 76.8245451,55.8522807 72.6545334,51.6821351 Z",
  id: "Shape",
  transform: "translate(38.500000, 38.500000) scale(-1, 1) translate(-38.500000, -38.500000) "
})));

var SvgBuildingRenovated = function SvgBuildingRenovated(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 145 129",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBuildingRenovated, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/building-renovated.765c5892.svg";
export { ForwardRef as ReactComponent };